module.exports = __webpack_public_path__ + "static/media/bookmark.b6240368.svg";